<template>
	<div style="display: flex; flex-direction: column; margin-left: 25px; margin-right: 25px; margin-top: 20px;">
		<div class="miniCard"
			style="background: RGBA(236, 240, 243, 1); border-radius: 16px; display: flex; flex-direction: column;" :style="{boxShadow: !isPdfShow ? '5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF' : '', background: !isPdfShow ? ' RGBA(236, 240, 243, 1)' : '#E0E6EF'}">
			<div class="miniCardTop" @click="unflodClick" style="cursor: pointer;">
				<div style="display: flex; width: 100%; height: 34px;">
					<div style="display: flex; flex: 1;">
						<img style="width: 28px; height: 28px; margin-left: 15px; border-radius: 10px; margin-top: 3px;"
							:src="data && data.icon ? require('../../../assets/' + data.icon + '.png') : ''" alt="">
						<div style="margin-left: 10px; position: relative; margin-top: 3px;">
							<div v-html="$options.filters.reMate(data && data.titleLabel ? data.titleLabel : ' ')"></div>
							<div v-if="type != 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient(270deg, rgba(24,144,255,0) 0%, rgba(255,113,134,0) 0%, #FF7186 100%); border-radius: 5px; opacity: 0.3;">
							</div>
							<div v-if="type == 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient( 270deg, rgba(74,124,232,0) 0%, #4A7CE8 100%); border-radius: 5px; opacity: 0.3;">
							</div>
						</div>
						<QuestionMarkA v-if="data && data.questionMarkType" />
					</div>
					<div style="width: 34px; height: 34px; display: flex; justify-content: center; align-items: center;">
						<div :class="isUnfold ? 'unfoldImgTrue' : 'unfoldImgFalse'" style="width: 14px; height: 14px;">
						</div>
					</div>
				</div>
				<div
					style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 22px; margin-left: 53px; margin-right: 49px; margin-top: 1px;">
					{{ data && data.conclusion ? data.conclusion : ' ' }}</div>
			</div>
			<div v-show="isUnfold"
				style="background: rgba(255,255,255,0.85); margin-left: 5px; margin-right: 5px; margin-bottom: 5px; border-radius: 12px; padding-top: 5px; padding-bottom: 5px;">
				<div v-if="data && data.subTitle" style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 15px;">
					<div style="width: 4px; height: 14px; background: #4A7CE8; border-radius: 2px; margin-left: 15px;">
					</div>
					<div
						style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 22px; margin-left: 10px;">
						{{ '呼吸暂停' }}</div>
					<div
						style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 22px;">
						{{ data && data.extendData ? data.extendData.brePauseNum + '次' : '0次' }}</div>
					<div
						style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 22px;">
						{{ '，呼吸异常指数' }}</div>
					<div
						style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 22px;">
						{{ data && data.extendData ? data.extendData.ahi : ' ' }}</div>
					<QuestionMarkA style="margin-top: 0px;"/>
				</div>
				<div v-if="data && (data.leftTip || data.rightTip)" style="display: flex; align-items: center; margin-top: 10px;">
					<div v-if="data && data.leftTip" style="width: 16px; height: 5px; background: rgba(24,144,255,0.15); margin-left: 15px; border: 1px dotted #4A7CE8;"></div>
					<div
						style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; margin-left: 4px;">
						{{ data && data.leftTip ? data.leftTip : ' ' }}</div>
					<div
						style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; flex: 1; text-align: right; margin-right: 15px;">
						{{ data && data.rightTip ? data.rightTip : ' ' }}</div>
				</div>
				<div :id="echartId" style="height: 165px;"></div>
				<div v-if="data && data.descLabel"
					style="background: linear-gradient(225deg, rgba(148,192,249,0.1) 0%, rgba(173,195,243,0.1) 100%); border-radius: 8px; border: 2px rgba(74, 124, 232, 0.1) solid; margin-left: 15px; margin-right: 15px; padding: 15px; margin-bottom: 10px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 21px;">
					{{ data && data.descLabel ? data.descLabel : ' '  }}</div>
			</div>

			<div v-show="isUnfold"
				style="background: rgba(255,255,255,0.85); border-radius: 12px; margin-bottom: 5px; margin-left: 5px; margin-right: 5px;">
				<div style="height: 142px; position: relative; margin: 15px;">
					<div style="height: 100%; position: absolute; z-index: 0; width: 100%; padding-top: 0px;">
						<el-carousel :interval="5000000" arrow="never" height="142px" :loop="false" indicator-position='none' ref="contentCardBaseBElCarouselRef" @change="carouselChange" >
							<el-carousel-item v-for="(item,index) in fragmentData || []" :key="index" >
								<div style="display: flex; flex-direction: column;">
									<div style="width: 100%; height: 100%; display: flex; padding-left: 0px;">
										<div v-for="(subItem,subIndex) in item || []" style="width: 260px; height: 111px; background: linear-gradient(225deg, rgba(148,192,249,0.1) 0%, rgba(173,195,243,0.1) 100%); border-radius: 8px; border: 2px solid rgba(173,195,243,0.1); display: flex; flex-direction: column;" :style="{marginRight: subIndex != 2 ? '15px' : '0px'}">
											<div v-if="subIndex < 3" style="display: flex; flex-direction: column;">
												<div style="display: flex; justify-content: space-between;margin-left: 15px; margin-right: 15px; margin-top: 9px;">
													<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 21px;">{{ subItem.time || '' }}</div>
													<div style="display: flex;">
														<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 21px;">持续</div>
														<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(74, 124, 232, 1); line-height: 21px;">{{ subItem.duration || '' }}</div>
													</div>
												</div>
												<div style="width: 230px; height: 60px; border-radius: 4px; border: 1px solid rgba(74,124,232,0.2); margin-top: 5px; align-self: center;">
													<ContentCardBaseC :echartId="'FragmentChartId' + index + subIndex" :option="subItem.echartsOption"></ContentCardBaseC>
												</div>
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<img 
					style="position: absolute; width: 96px; height: 96px; left: -25px; top: 12px; z-index: 1;"
					:src="require('../../../assets/' + (leftBtnState == 1 ? 'icon_dean_home_bg_card_icon_12' : 'icon_dean_home_bg_card_icon_11') + '.png')" 
					onselectstart="return false" 
					alt=""
					@click="clickArrow(1)"
					v-if="currentPage != 1"
					@mouseover="leftBtnHover"
					@mouseout="leftBtnRemoveHover"
					/>
					<img 
					style="position: absolute; width: 96px; height: 96px; right: -25px; top: 12px; z-index: 1;"
					:src="require('../../../assets/' + (rightBtnState == 1 ? 'icon_dean_home_bg_card_icon_14' : 'icon_dean_home_bg_card_icon_13') + '.png')" 
					onselectstart="return false" 
					alt=""
					@click="clickArrow(2)"
					v-if="fragmentData && fragmentData.length > 1 && currentPage != fragmentData.length"
					@mouseover="rightBtnHover"
					@mouseout="rightBtnRemoveHover"
					/>
					<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 21px; bottom: 0px; left: 276px; position: absolute;">*仅展示部分典型呼吸事件片段，非所有的事件</div>
				</div>
			</div>

		</div>
	</div>
</template>
  
<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import QuestionMarkA from '../component/questionMarkA.vue'
import data from '../../../utils/data';
import getEchartsOptionLineB1 from '../component/options/echartsOptionLineB1.js'
import ContentCardBaseC from '../component/contentCardBaseC.vue'

export default {
	components: {
		QuestionMarkA,
		ContentCardBaseC
	},
	filters: {
		reMate(val) {
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {
		data: null,
		echartId: {
			type: String,
			default: null,
		},
		option: {
			type: Object,
			default: null
		},
		isPdfShow: {
			type: Boolean,
			default: false
		},
		isFold: {
			type: Boolean,
			default: false
		},
		type: {
			type: Number,
			default: 0 // 0 - 红色，1 - 黄色
		}
	},
	watch: {
		option(newVal, oldVal) {
			if (newVal) {
				let option = newVal;
				this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
				this.myChart_Bar.setOption(option, true);
				window.addEventListener('resize', () => {
					this.myChart_Bar.resize();
				});
				this.$forceUpdate()
			}
		}
	},
	data() {
		return {
			isUnfold: true,
			leftBtnState: 0,
			rightBtnState: 0,
			currentPage: 1,
			fragmentData: null
		};
	},
	created() { },
	mounted() {
		if (this.$props.isFold == true) {
			this.isUnfold = false;
		}
		if (this.$props.option) {
			let option = this.$props.option;
			this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
			this.myChart_Bar.setOption(option, true);
			window.addEventListener('resize', () => {
				this.myChart_Bar.resize();
			});
			this.$forceUpdate()
		}
		let needArr = [];
		let tempArr = JSON.parse(JSON.stringify(this.$props.data.extendData.breathSliceDataList || []))
		
		for (let i = 0; i < tempArr.length; i++) {
			let needItem = JSON.parse(JSON.stringify(tempArr[i]));
			needItem.echartsOption = getEchartsOptionLineB1(needItem.data || [])
			needArr.push(needItem);
		}
		this.fragmentData = this.convertTwoDimensionalArray(needArr)
	},
	methods: {
		unflodClick() {
			this.isUnfold = !this.isUnfold;
		},
		carouselChange(){
			let activeIndex = this.$refs.contentCardBaseBElCarouselRef.activeIndex
      		this.currentPage = Number(activeIndex + 1)
		},
		clickArrow(type) {
			if(type == 1){
				this.$refs.contentCardBaseBElCarouselRef.prev()
			}else {
				this.$refs.contentCardBaseBElCarouselRef.next()
			}
		},
		leftBtnHover() {
			this.leftBtnState = 1;
			this.rightBtnState = 0;
		},
		leftBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		rightBtnHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 1;
		},
		rightBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		// 转换为二维数组 - 每行3个元素
		convertTwoDimensionalArray(arr) {
			if (!arr || arr.length == 0) {
				return
			}
			let needArr = [];
			for (let i = 0; i < arr.length; i += 3) {
				needArr.push(arr.slice(i, i + 3));
			}
			return needArr;
		},
	},
};
</script>
<style lang="scss" scoped>
.miniCard ::v-deep {
	background: #ECF0F3;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_10.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_9.png') no-repeat no-repeat;
		background-size: contain;
	}

	.richContentStyle {
		display: flex;
	}

	.richTextStyleNormal {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(31, 38, 53, 1);
		line-height: 25px;
	}

	.richTextStyleRed {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 25px;
	}
}

.miniCard:hover {
	background: rgba(223, 232, 252, 1) !important;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_12.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_11.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.miniCardTop {
	background: rgba(255, 255, 255, 0.85);
	border-radius: 12px;
	border: 1px solid #FFFFFF;
	display: flex;
	flex-direction: column;
	padding-top: 12px;
	padding-bottom: 15px;
	margin: 5px;
}

</style>
  